import React from 'react';
import { Modal, Button } from 'antd';
import styled from 'styled-components';

const CenteredParagraph = styled.p`
  text-align: center;
`;

function ModalIpNotAllowed({ visible = false, onClose }) {
  return (
    <Modal
      title="⚠️ Alerta"
      visible={visible}
      footer={[
        <Button key="ok" type="primary" onClick={onClose}>
          OK
        </Button>,
      ]}
      closable={false}
    >
      <CenteredParagraph>
        Detectamos uma tentativa de acesso à sua instituição fora da rede permitida. Isso pode indicar um acesso não autorizado à sua conta.
      </CenteredParagraph>
      <CenteredParagraph>Para garantir a segurança dos seus dados, o acesso foi bloqueado.</CenteredParagraph>
      <CenteredParagraph>
        Entre em contato com sua instituição para obter mais informações e resolver este problema.
      </CenteredParagraph>
    </Modal>
  );
}

export default ModalIpNotAllowed;
